<template>
 <!-- Implementação Site -->
     <SearchBox :dataObject="approvedUrlsByIdt" searchCritery="desUrl"
                   displayValue="desUrl" idToSelectOptions="idtUserSupplierUrl"
                   placeholder="Selecione um site"
                   :wrapCustomClass="'wrapper_site'"
                   v-model="selectedSite"
                   :class="!approvedUrlsByIdt.length ? 'loading-placeholder' : ''">
          <template v-slot:customView="{ rows, pickFunc }">
            <b-table hover small :items="rows" :fields="visibleColumns"
            primary-key="idtUserSupplierUrl"
                     table-class="text-dark" thead-class="table-small-title"
                     tbody-tr-class="pointer text-break tr-align-middle"
                     @row-clicked="pickFunc($event)">
              <template slot="[favorite]" slot-scope="data">
                <div class="text-center">
                  <b-button
                  :class="[data.item.isFavorite !== '0' ? 'btn-favorite' : 'btn-no-favorite']"
                  :ref="'star-'+data['index']"
                  @click.stop="updateFavorite(data);"
                  variant="link"
                  size="sm"
                  class="align-baseline star"
                  style="">
                  </b-button>
                </div>
              </template>
            </b-table>
          </template>
    </SearchBox>
      <!-- Fim  Implementação site -->
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import SearchBox from '@/components/SearchBox';

export default {
  name: 'SearchBoxSite',
  components: {
    SearchBox,
  },
  data() {
    return {
      visibleColumns: [{
        key: 'desUrl',
        label: 'Site',
        thClass: 'no-border-bottom',
        tdClass: 'light-border-bottom',
      }, {
        key: 'favorite',
        label: 'Favorito',
        thClass: 'no-border-bottom',
        tdClass: 'light-border-bottom',
      }],
      selectedSite: null,
    };
  },
  props: {
    value: {},
  },
  methods: {
    ...mapActions(['updateToFavorite', 'getApprovedUrlsByIdt']),
    async updateFavorite(data) {
      await this.updateToFavorite(data.item);
      const wrap = document.querySelector('.wrapper_site');
      wrap.scrollTo(0, 0);
    },
  },
  computed: {
    ...mapGetters([
      'approvedUrlsByIdt',
      'pageAdvertiser',
      'approvedUrls',
    ]),
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selectedSite = val;
      },
    },
    pageAdvertiser: {
      immediate: true,
      handler(value) {
        if (value !== null && value !== undefined) {
          this.getApprovedUrlsByIdt(value.id.toString());
        }
      },
    },
    selectedSite: {
      handler(val, old) {
        if (val !== old) {
          this.$emit('input', val);
          this.$emit('change', val);
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-favorite{
  width:40px;
  height:34px;
  background: url('~@/assets/star_yellow.png') center center no-repeat;
}
.btn-no-favorite{
  width:40px;
  height:34px;
  background: url('~@/assets/star.svg') center center no-repeat;
}
</style>
